import { client } from '../../../utils';
import { DropdownType } from '../../../types';

export const getFreelancerTags = (): Promise<DropdownType[]> => (
  client.get('/freelancer-tag')
    .then(({ data: { result } }: { data: { result: DropdownType[] } }) => result)
);
